import {AxiosError} from "axios";
import {API_URL, JSON_URL, LOCALE, GZ_API_URL} from "modules/constants";
import {ApiError} from "./ApiError";
import {IApiResponse} from "modules/types";
import {isObject} from "lodash";
import {IProfileUpdate} from "modules/stores/Models/Profile";
import {HttpClientService} from "./http_client.service";

const onCatchNetworkError = ({response, message = "Network error"}: AxiosError<ApiError>) => {
	const data = response?.data;
	const error = isObject(data)
		? data
		: {
				errors: [new ApiError(message)],
		  };

	return Promise.reject(error).catch((err) =>
		ApiError.CHECK(err as IApiResponse, response?.status)
	);
};

const APIClient = new HttpClientService({
	baseURL: API_URL,
	withCredentials: true,
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore An error is written that axios is imported from different folders
	onCatchNetworkError,
});
const GZ_APIClient = new HttpClientService({
	baseURL: GZ_API_URL,
	withCredentials: true,
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore An error is written that axios is imported from different folders
	onCatchNetworkError,
});
const JSONClient = new HttpClientService({
	baseURL: JSON_URL,
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore An error is written that axios is imported from different folders
	onCatchNetworkError,
});

export interface IAnswersPayload {
	answers: number[];
	favoriteTeam: number;
}

export const Api = {
	JSON: {
		squads: <T>() => JSONClient.get<T>(`squads.json`, {t: Date.now()}),
		questions: <T>() => JSONClient.get<T>(`questions/${LOCALE}.json`),
		lang: <T>() => JSONClient.get<T>(`langs/${LOCALE}.json`),
		countries: <T>() => JSONClient.get<T>(`countries.json`),
	},
	Country: {
		get: <T>() => APIClient.get<T>("country"),
	},
	Answers: {
		save: <T>(params: IAnswersPayload) => APIClient.post<T>("answers/save", params),
	},
	User: {
		get: <T>() => GZ_APIClient.get<T>("user"),
	},
	Profile: {
		get: <T>() => APIClient.get<T>("profile", {t: Date.now()}),
		save: <T>(params: IProfileUpdate) => APIClient.post<T>("profile/save", params),
	},
};

export * from "./ApiError";
